rs.module("controls/framework/ag/agValueParsing",

    [],

    function () {

        //
        // Get the parser by the given name
        //
        function parse(value, options, params) {

            var name = options.name;

            // Validate the parser name
            if (name && !parsers[name]) {
                throw new Error(`No such custom ag value parser by the name of '${name}'.`);
            }

            // Name could be null if no parser
            if (!name) {
                return value;
            }

            // If its a numeric, and its null or empty, call it null
            if (params.column.colDef.context["_lrs/isNumeric"] && value == null || value === "") {
                return null;
            }

            // Let the parser do the parsing using the params from ag, and the options configured in razor
            return parsers[name](value, params);
        }

        var parsers = {

            //
            // Percent parser
            //
            percent: function (value) {

                value = value.trim();

                // See if the % is included - if so we assume what they entered is exactly what they want
                var percentSpecified = value.endsWith("%");

                const parsed = parseFloat(value);

                if (Number.isFinite(parsed)) {
                    return (parsed >= 1 || parsed <= -1 || percentSpecified) ? (parsed / 100) : parsed;
                }
                else {
                    return value;
                }
            },

            //
            // Currency parser
            //
            currency: function (value) {

                value = value.trim();

                // See if parens are being used to denote negative
                var negativeParens = value.startsWith("(") && value.endsWith(")");

                // Strip known punctuation and parse
                var parsed = parseFloat(value.replace(/[$,()]/g, ""));

                return Number.isFinite(parsed) ? (parsed * (negativeParens ? -1 : 1)) : value;
            }
        };

        // Exported public API
        var exports = {
            parse
        };

        return exports;
    }
);